<template>
  <div class="container" style="width: 1280px;">
    <div class="one">
      <div class="schoolWZ">
        <div class="SCLeft">
          <span>职业大类</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator="">
            <el-breadcrumb-item v-for="(item,index) in jogList" :key="index"><a @click="isT(item.code)"
                :class=" item.code ==  firstCode? 'active' :''">{{item.name}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <!-- <div class="em"></div> -->
      <div class="schoolWZ">
        <div class="SCLeft">
          <span>职业小类</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator="">
            <el-breadcrumb-item v-for="(item,key,index) in jogList[firstCode].children"
            :key="key"><a
                @click="isT2(key)" :class=" key ==secondCode  ? 'active' :''">
                {{item}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getJobType
  } from '../libs/tools.js'
  export default {
    name: "",
    components: {

    },
    data() {
      return {
        jogList:[],
        firstCode:"",
        secondCode:"",
        // 面包屑渲染
        typeFirst: [],
        typeSecond: [],
        typeThird: [],
        typeId: "",
        typeIdinfo: {}
      }
    },
    methods: {
      isT(code) {
        this.firstCode = code;
      },
      isT2(code) {
        this.secondCode = code
        this.getMajor(code);
      },
      getMajor(code){
        this.$emit("select",code)
      }
    },
    created() {
      this.jogList= getJobType();
      this.firstCode = "02";
      this.secondCode = '0201'
      this.getMajor(this.secondCode)
    }


  }
</script>

<style scoped>
  .one {
    margin-top: 20px;
    justify-content: flex-start;
    width: 100%;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 200px;


  }

  .el-breadcrumb {}

  .one span {
    line-height: 40px;
    margin-right: 8px;
  }

  .schoolWZ {
    width: 100%;
    height: auto;
    display: flex;
  }


  .schoolWZ .SCLeft {
    width: 115px;
  }

  .schoolWZ .SCmain {
    width: 64px;
    height: 60px;
    margin-right: 15px;
    margin-top: 10px;

  }

  .schoolWZ .SCmain a {
    display: block;
    text-align: center;
    line-height: 32px;
    font-weight: 600;
    height: 32px;
    color: #333333;
    opacity: 1;
    cursor: pointer;
    font-size: 14px;

    margin: 0 10px;
  }

  .active {
    background: #e63233;
    color: #fff !important;
    border-radius: 16px;

    box-sizing: border-box;
  }

  .schoolWZ .SCbottom {
    width: 100%;
    text-align: left;
    padding-bottom: 10px;
    border-bottom: 1px #eee9e9 solid;
  }

  .schoolWZ:nth-of-type(3) .SCbottom {
    padding-bottom: 10px;
    border-bottom: none;
  }

  .schoolWZ .SCbottom a {
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 20px;
    padding: 4px 6px;
    color: #333333;
    opacity: 1;
  }




</style>



// WEBPACK FOOTER //
// src/components/jobtype1.vue